function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityArrowInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.74,
    height: 16.001,
    viewBox: "0 0 26.74 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.74 16H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h18.74a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4zM9.865 3a4.866 4.866 0 0 0-.206 9.728H9.868a4.884 4.884 0 0 0 2.881-.947 4.879 4.879 0 0 0 6.328-.478 4.864 4.864 0 0 0-3.234-8.3h-.207a4.913 4.913 0 0 0-2.884.946A4.82 4.82 0 0 0 9.865 3zm0 7.695a2.824 2.824 0 1 1 2-4.822l2.472 2.476a1.021 1.021 0 0 0 .725.3A1.021 1.021 0 0 0 15.78 6.9l-1.504-1.5a2.82 2.82 0 1 1-.635 4.465l-2.474-2.478a1.028 1.028 0 0 0-.724-.3 1.024 1.024 0 0 0-.723 1.747l1.5 1.5a2.791 2.791 0 0 1-1.355.361z",
    style: {}
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityArrowInverted);
export default __webpack_public_path__ + "static/media/infinity-arrow-inverted.e6a3450d.svg";
export { ForwardRef as ReactComponent };